import { GITA_JAYANTI } from "../../content/activities";
import { t } from "../../i18n/dict";
import { Page } from "../../layout/Page";
import { Button } from "../../ui/Button";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";

/**
 * The old site's `/gita-jayanti-2021`: a bare two-line heading ("Gita
 * Jayanti 2021" / "Singapore") and a "click to know more >>" link, all
 * pointing at the external Gita Jayanti Singapore event site. English
 * only - no Hindi twin.
 */
export function GitaJayantiPage() {
  return (
    <Page title="Gita Jayanti 2021" heading="Gita Jayanti 2021">
      <Section>
        <Reveal>
          <p className="eyebrow">{GITA_JAYANTI.location}</p>
          <div className="mt-5">
            <Button href={GITA_JAYANTI.href} external>
              {t("en", "knowMore")}
            </Button>
          </div>
        </Reveal>
      </Section>
    </Page>
  );
}
